document.addEventListener("DOMContentLoaded", () => {

  var
    check,
    save,
    initCheck,
    initSave,
    sections = 7,
    toSave;

  // Al mandar una petición AJAX
  Livewire.hook('message.sent', (message, component) => {
    check = false, save = false;
    $('#alert_error').addClass('d-none');
    // Si viene de la función check - formularioComponent
    if (message.updateQueue[0].payload.event === 'check') {
      check = true, initCheck = 0, toSave = true;
    }

    // Si viene de la función save - sectionsComponent
    if (message.updateQueue[0].payload.event === 'save') {
      save = true, initSave = 1;
    }
  })


  Livewire.hook('message.processed', (message, component) => {
    // Si viene de la función check - formularioComponent
    if (check) {

      // Validar que las secciones no tengan erroress
      if (component.fingerprint.name == 'creacion.datos-personales') {
        initCheck++;
        if (component.serverMemo.errors.length !== 0) {
          toSave = false;
        }
      }

      if (component.fingerprint.name == 'creacion.certificaciones') {
        initCheck++;
        if (component.serverMemo.errors.length !== 0) {
          toSave = false;
        }
      }

      if (component.fingerprint.name == 'creacion.domicilio') {
        initCheck++;
        if (component.serverMemo.errors.length !== 0) {
          toSave = false;
        }
      }

      if (component.fingerprint.name == 'creacion.area-cobertura') {
        initCheck++;
        if (component.serverMemo.errors.length !== 0) {
          toSave = false;
        }
      }

      if (component.fingerprint.name == 'creacion.datos-contacto') {
        initCheck++;
        if (component.serverMemo.errors.length !== 0) {
          toSave = false;
        }
      }

      if (component.fingerprint.name == 'creacion.horario-atencion') {
        initCheck++;
        if (component.serverMemo.errors.length !== 0) {
          toSave = false;
        }
      }

      if (component.fingerprint.name == 'creacion.costos') {
        initCheck++;
        if (component.serverMemo.errors.length !== 0) {
          toSave = false;
        }
      }

      if (initCheck == sections && toSave) {
        $('#alert_error').addClass('d-none');
        // Si no hubo errores en ninguna sección, se hace el emit a store - datosPersonales
        Livewire.emit('store');
      } else {
        // Se scrollea al inicio del formulario y muestra un mensaje
        $('#form').get(0).scrollIntoView();
        $('#alert_error').removeClass('d-none');
      }
    }

    // Si viene de la función save - sectionsComponent
    if (save) {

      // Esperar a que todos los emits terminen, menos datosPersonales porque el inició
      if (component.fingerprint.name == 'creacion.certificaciones') {
        initSave++;
      }

      if (component.fingerprint.name == 'creacion.domicilio') {
        initSave++;
      }

      if (component.fingerprint.name == 'creacion.area-cobertura') {
        initSave++;
      }

      if (component.fingerprint.name == 'creacion.datos-contacto') {
        initSave++;
      }

      if (component.fingerprint.name == 'creacion.horario-atencion') {
        initSave++;
      }

      if (component.fingerprint.name == 'creacion.costos') {
        initSave++;
      }

      // Cuando terminen todos los emits
      if (initSave == sections) {
        Livewire.emit('completeForm');
        return false;
      }
    }
  })
});


document.addEventListener("livewire:load", function (event) {
  // Abrir modal
  window.addEventListener('open-modal', e => {
    $('#' + e.detail.name).modal('show');
    activeValidations();
  })

  // Cerrar modal
  window.addEventListener('close-modal', e => {
    $('#' + e.detail.name).modal('hide');
  })

  // Selectpicker
  window.addEventListener('selectpicker', event => {
    $('.selectpicker').selectpicker();
  })

  // Selectpicker: Colonia
  window.addEventListener('selectpickerColonia', event => {
    $('.selectpicker.colonia').val(0);
    $('.selectpicker.colonia').selectpicker('refresh');
  })

  // Scroll to ID
  window.addEventListener('scrollToID', e => {
    $('#' + e.detail.id).get(0).scrollIntoView();
  })

  window.addEventListener('click', e => {

    $('[data-toggle="popover"]').popover()
  })

  // ACTIVAR VALIDACIONES

  function activeValidations() {

    // Números (teléfonos o campos con números enteros)
    $(".numbers").on('input keydown paste', function () {
      var inputText = $(this).val();
      var resultText = inputText.replace(/[^0-9]/g, '');
      $(this).val(resultText);
    });

    // Números con decimales, permite comas y puntos
    $(".decimal").on("input keydown paste", function (event) {
      var inputText = $(this).val();
      var resultText = inputText.replace(/[^0-9.]/g, '');
      $(this).val(resultText);
    });

    // Longitud de 4
    $(".long_4").keyup(function (e) {
      var max = 4;
      if ($(".long_4").val().length > max) {
        $(".long_4").val($(".long_4").val().substr(0, max));
      }
    });

    // Longitud de 5
    $(".long_5").keyup(function (e) {
      var max = 5;
      if ($(".long_5").val().length > max) {
        $(".long_5").val($(".long_5").val().substr(0, max));
      }
    });


    // Longitud de 10
    $(".long_10").keyup(function (e) {
      var max = 10;
      if ($(".long_10").val().length > max) {
        $(".long_10").val($(".long_10").val().substr(0, max));
      }
    });

    // Longitud de 50
    $(".long_50").keyup(function (e) {
      var max = 50;
      if ($(".long_50").val().length > max) {
        $(".long_50").val($(".long_50").val().substr(0, max));
      }
    });

    // Longitud de 500
    $(".long_500").keyup(function (e) {
      var max = 500;
      if ($(".long_500").val().length > max) {
        $(".long_500").val($(".long_500").val().substr(0, max));
      }
    });

  };

});
